<div class="promo-t2-page">
    <!-- =========================================
       ENCABEZADO
  ========================================== -->
    <section class="promo-t2-header">
        <span class="promo-t2-eyebrow">
            PROMOCIÓN
        </span>
        <h1 class="promo-t2-title">
            {{ promo }}
        </h1>
        <p class="promo-t2-subtitle">
            Selecciona los productos y la cantidad que deseas llevar.
        </p>
    </section>
    <!-- =========================================
       CONTENIDO
  ========================================== -->
    <section class="promo-t2-content">
        <!-- PRODUCTOS -->
        <div class="promo-t2-products" *ngIf="products.length > 0">
            <article class="promo-t2-product" *ngFor="let product of products">
                <!-- =====================================
             IMAGEN
        ====================================== -->
                <div class="promo-t2-image">
                    <img [src]="product.urlFotoAgrupador || product.urlFoto" [defaultImage]="defImgProd"
                        [alt]="product.producto || 'Producto Nina'">
                </div>
                <!-- =====================================
             INFORMACIÓN DEL PRODUCTO
        ====================================== -->
                <div class="promo-t2-info">
                    <h2 class="promo-t2-product-name">
                        {{ product.producto }}
                    </h2>
                    <p class="promo-t2-product-description" *ngIf="product?.productoAgrupador">
                        {{ product?.descripcionProducto }}
                    </p>
                    <!-- PRECIOS -->
                    <div class="promo-t2-prices">
                        <span class="promo-t2-price-normal">
                            {{ product.precioNormal | currency:'USD':'symbol':'1.0-0' }}
                        </span>
                        <span class="promo-t2-price-promo">
                            {{ product.precioPromocion | currency:'USD':'symbol':'1.0-0' }}
                        </span>
                    </div>
                </div>
                <!-- =====================================
             CANTIDAD
        ====================================== -->
                <div class="promo-t2-quantity">
                    <span class="promo-t2-quantity-label">
                        CANTIDAD
                    </span>
                    <div class="promo-t2-quantity-controls">
                        <button mat-mini-fab class="promo-t2-qty-button" type="button" aria-label="Menos"
                            (click)="changeQty('restar', product)">
                            <mat-icon>remove</mat-icon>
                        </button>
                        <div class="promo-t2-qty-value">
                            {{ product.qty ? product.qty : 0 }}
                        </div>
                        <button mat-mini-fab class="promo-t2-qty-button" type="button" aria-label="Más"
                            (click)="changeQty('sumar', product)">
                            <mat-icon>add</mat-icon>
                        </button>
                    </div>
                </div>
                <!-- =====================================
             TOTAL
        ====================================== -->
                <div class="promo-t2-total">
                    <span class="promo-t2-total-label">
                        TOTAL
                    </span>
                    <span class="promo-t2-total-value">
                        {{
                        ((product.qty > 0 ? product.qty : 0) * product.precioPromocion)
                        | currency:'USD':'symbol':'1.0-0'
                        }}
                    </span>
                </div>
            </article>
        </div>
        <!-- =========================================
         BOTÓN
    ========================================== -->
        <aside class="promo-t2-action">
            <button class="promo-t2-continue" mat-raised-button type="button" (click)="proceder()"
                [disabled]="selectedProductsCart.length === 0">
                CONTINUAR
            </button>
        </aside>
    </section>
</div>